<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center ui-log" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/4 lg:w-3/4 xl:w-3/12 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="p-4">

          <div class="vx-row justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-1/1d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container ">

                <div class="vx-card__title mb-4 pb-5">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

              <login-jwt></login-jwt>
                <!-- <vs-tabs>
                  <vs-tab label="JWT">
                    <login-jwt></login-jwt>
                  </vs-tab>

                  <vs-tab label="Firebase">
                    <login-firebase></login-firebase>
                  </vs-tab>

                  <vs-tab label="Auth0">
                    <login-auth0></login-auth0>
                  </vs-tab>
                </vs-tabs> -->

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from "./LoginJWT.vue"
// import LoginFirebase from "./LoginFirebase.vue"
// import LoginAuth0 from "./LoginAuth0.vue"

export default {
  components: {
    LoginJwt,
    // LoginFirebase,
    // LoginAuth0
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  // min-height: 405px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.ui-log{
  background-color:white;
}
</style>
